import { useState, useEffect } from "react";
import { Divider, Group, TextInput, Button, Paper, Text, Stack, Table, Select, Title, Checkbox } from "@mantine/core";
import { Card, message, Flex, Spin, Alert } from "antd";
import { useAuthContext } from "../../Hooks/UseAuthContext";






const Termsandconditions = ({ rectification = false, stepData, submissionDetails, onSuccess }) => {
    const { user } = useAuthContext();
    const [loading, setLoading] = useState(false);
    const [companyProfile, setCompanyProfile] = useState(null);
    const [compliancedetails, setCompliancedetails] = useState(null);
    const [banksdetails, setbanksdetails] = useState(null);
    const [merchantduedeligencedetails, setmerchantduedeligencedetails] = useState(null);
    const [boardresolution, setboardresolution] = useState(null);
    const [merchantcriminalundertaking, setmerchantcriminalundertaking] = useState(null);
    const [uploadeddocsid, setuploadeddocsid] = useState(null);
    const [authorizedSignatory, setAuthorizedSignatory] = useState("");

    const [acceptMainTerms, setAcceptMainTerms] = useState(false);

    const [acceptedServices, setAcceptedServices] = useState([]);

    const handleServiceAcceptance = (index, value) => {

        const updatedServices =
            [...acceptedServices];

        updatedServices[index].is_accepted =
            value === "Yes";

        updatedServices[index].accepted_at =
            new Date();

        setAcceptedServices(updatedServices);
    };

    const getUserData = async () => { // for get the updated user data after company profile submission
        await fetch('https://api.boompay.in/get-user', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${user}`,
            }
        });
        // const data = await response.json();
        // if (response.status === 200) {
        //     // console.log(data.user);
        //     setUserprofile(data.user);
        //     setActive(data.user.Completed_step);
        //     setLoading(false);
        // } else if (response.status === 401) {
        //     setLoading(false);
        //     console.log('Unauthorized access. Please log in again.');
        //     message.error('Unauthorized access. Please log in again.');
        // } else if (response.status === 404) {
        //     setLoading(false);
        //     console.log('User not found.');
        //     message.error('User not found.');
        // } else {
        //     setLoading(false);
        //     console.log('An error occurred while fetching user data.');
        //     message.error('An error occurred while fetching user data.');
        // }
    }

    const handleSubmitTermsAndConditions = async () => {

        try {

            setLoading(true);
            // =====================================
            // VALIDATION
            // =====================================

            if (!authorizedSignatory) {
                message.error("Please select authorized signatory");
                return;
            }

            if (!acceptMainTerms) {
                message.error("Please accept main terms and conditions");
                return;
            }

            // =====================================
            // CHECK ALL SERVICES ACCEPTED
            // =====================================

            const notAcceptedService =
                acceptedServices.some((service) => !service.is_accepted);

            if (notAcceptedService) {
                message.error("Please accept all service terms and conditions");
                return;
            }

            // =====================================
            // API PAYLOAD
            // =====================================

            const payload = {

                Registered_Name_of_Company: companyProfile?.Company_name,

                Registered_PAN_Number: companyProfile?.Company_PAN_number,

                Registered_GST_Number: companyProfile?.Company_GST_number,

                authorized_signatory_name: authorizedSignatory,

                accepted_main_terms: acceptMainTerms,

                accepted_services: acceptedServices,

                Upload_documents_schema_id: uploadeddocsid,

                Merchant_criminal_undertaking_schema_id: merchantcriminalundertaking?._id,

                Board_of_resolution_schema_id: boardresolution?._id,

                Bank_details_schema_id: banksdetails?._id,

                Merchant_due_deligence_schema_id: merchantduedeligencedetails?._id,

                Compliance_and_MAF_schema_id: compliancedetails?._id,

                Company_profile_schema_id: companyProfile?._id,

                Completed_step: 10,
            };

            // =====================================
            // API CALL
            // =====================================

            const response = await fetch('https://api.boompay.in/submit-details-for-onbaord-verification', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            // =====================================
            // RESPONSE
            // =====================================
            if (response.status === 201) {
                message.success(data.message);
                getUserData();
                setLoading(false);
            } else if (response.status === 400) {
                message.error(data.message);
                setLoading(false);
            } else if (response.status === 404) {
                message.error(data.message);
                setLoading(false);
            }
            else if (response.status === 401) {
                setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else {
                setLoading(false);
                console.log('An error occurred while submitting the form.');
                message.error('An error occurred while submitting the form.');
            }
        } catch (error) {
            console.log(error);
            message.error(
                "Internal Server Error"
            );

        } finally {

            setLoading(false);
        }
    };

    const handleRectificationSubmit = async () => {
        // =====================================
        // VALIDATION
        // =====================================

        if (!authorizedSignatory) {
            message.error("Please select authorized signatory");
            return;
        }

        if (!acceptMainTerms) {
            message.error("Please accept main terms and conditions");
            return;
        }

        // =====================================
        // CHECK ALL SERVICES ACCEPTED
        // =====================================

        const notAcceptedService = acceptedServices.some((service) => !service.is_accepted);

        if (notAcceptedService) {
            message.error("Please accept all service terms and conditions");
            return;
        }

        // =====================================
        // API PAYLOAD
        // =====================================

        const payload = {

            Registered_Name_of_Company:
                companyProfile?.Company_name,

            Registered_PAN_Number:
                companyProfile?.Company_PAN_number,

            Registered_GST_Number:
                companyProfile?.Company_GST_number,

            authorized_signatory_name:
                authorizedSignatory,

            accepted_main_terms:
                acceptMainTerms,

            accepted_services:
                acceptedServices,

            Upload_documents_schema_id:
                uploadeddocsid,

            Merchant_criminal_undertaking_schema_id:
                merchantcriminalundertaking?._id,

            Board_of_resolution_schema_id:
                boardresolution?._id,

            Bank_details_schema_id:
                banksdetails?._id,

            Merchant_due_deligence_schema_id:
                merchantduedeligencedetails?._id,

            Compliance_and_MAF_schema_id:
                compliancedetails?._id,

            Company_profile_schema_id:
                companyProfile?._id,

            Completed_step: 10,
        };
        setLoading(true);
        try {
            const response = await fetch('https://api.boompay.in/put/rectify/terms-and-conditions', {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                },
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (response.status === 201) {
                //console.log(data.message);
                message.success(data?.message)
                onSuccess(); // Refresh user data to update.
                setLoading(false);
            } else if (response.status === 400) {
                message.error(data.message);
                console.log(data.message);
            } else if (response.status === 401) {
                message.error('Unauthorized access. Please log in again.');
                console.log('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                message.error('User not found.');
                console.log('User not found.');
            } else {
                message.error('An error occurred while submitting company profile.');
                console.log('An error occurred while submitting company profile.');
            }
        } catch (error) {
            message.error('An error occurred while submitting company profile.');
            console.error('Error:', error);
        }
        setLoading(false);
    }



    useEffect(() => {
        const getCompanyProfile = async () => {
            const response = await fetch('https://api.boompay.in/get-company-profile', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                //console.log(data.Companyprofile);
                setCompanyProfile(data.Companyprofile);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Company profile not found.');
                message.error('Company profile not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getComplianceandmaf = async () => {
            const response = await fetch('https://api.boompay.in/get-compliance-details-and-maf', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Complianceandmafdetails);
                setCompliancedetails(data.Complianceandmafdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Compliance details not found.');
                message.error('Compliance details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getbanksdetails = async () => {
            const response = await fetch('https://api.boompay.in/get-bank-details', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setbanksdetails(data.Banksdetails);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Banks details not found.');
                message.error('Banks details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getmerchantduedeligence = async () => {
            const response = await fetch('https://api.boompay.in/get-merchant-due-deligence', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setmerchantduedeligencedetails(data.Merchantduedeligence);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getboardofresolution = async () => {
            const response = await fetch('https://api.boompay.in/get-board-of-resolution', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setboardresolution(data.Boardresolution);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getmerchantcriminalundertaking = async () => {
            const response = await fetch('https://api.boompay.in/get-merchant-criminal-undertaking', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setmerchantcriminalundertaking(data.Merchantcriminalundertaking);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Merchant details not found.');
                message.error('Merchant details not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }
        const getuploadeddocs_id = async () => {
            const response = await fetch('https://api.boompay.in/get-uploaded-docs-id', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            if (response.status === 200) {
                // console.log(data.Banksdetails);
                setuploadeddocsid(data.docid);

                //  setUserprofile(data.user);
                // setActive(data.user.Completed_step);
                // setLoading(false);
            } else if (response.status === 401) {
                //setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                // setLoading(false);
                console.log('Document id not found.');
                message.error('Document id not found.');
            } else {
                // setLoading(false);
                console.log('An error occurred while fetching data.');
                message.error('An error occurred while fetching data.');
            }
        }

        if (user) {
            getCompanyProfile();
            getComplianceandmaf();
            getbanksdetails();
            getmerchantduedeligence();
            getboardofresolution();
            getmerchantcriminalundertaking();
            getuploadeddocs_id();
        }
    }, [user])

    useEffect(() => {

        if (companyProfile?.Services_opted) {

            const formattedServices =
                companyProfile.Services_opted.map(
                    (service) => ({

                        service_name: service,

                        is_accepted: false,
                    })
                );

            setAcceptedServices(formattedServices);
        }

    }, [companyProfile]);

    useEffect(() => {
        const getUserData = async () => {
            setLoading(true);
            const response = await fetch('https://api.boompay.in/get-submitted-details-for-rectification', {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${user}`,
                }
            });
            const data = await response.json();
            // console.log(data);

            if (response.status === 200) {
                const profile = data.RectificationDetails;
                // Authrized signatory
                setAuthorizedSignatory(profile.authorized_signatory_name || '');
                // Accept main terms
                setAcceptMainTerms(profile.accepted_main_terms || false);

                // Accepted services
                setAcceptedServices(profile.accepted_services || []);

                setLoading(false);
            } else if (response.status === 401) {
                setLoading(false);
                console.log('Unauthorized access. Please log in again.');
                message.error('Unauthorized access. Please log in again.');
            } else if (response.status === 404) {
                setLoading(false);
                console.log('User not found.');
                message.error('User not found.');
            } else {
                setLoading(false);
                console.log('An error occurred while fetching user data.');
                message.error('An error occurred while fetching user data.');
            }
        }

        if (user && rectification) {
            getUserData();
        }
    }, [user, rectification])
    return (
        <>
            <Flex gap="medium" vertical>
                <Spin spinning={loading} size="large" description="Please wait...">
                    <Card title="Terms & Conditions" style={{ "box-shadow": "rgba(0, 0, 0, 0.24) 0px 3px 8px", }}>
                        {/* <Alert type="info" title="Please upload all documents carefully for verification purposes. Ensure that every document is clear, properly scanned, and fully readable. Kindly make sure all required instructions have been followed, such as submitting documents on the company letterhead wherever applicable and including the authorized signatory’s signature, stamp, and other necessary details." showIcon /> */}
                        <Group>
                            <TextInput label="Company name" value={companyProfile?.Company_name || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company CIN number" value={companyProfile?.Company_CIN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company PAN number" value={companyProfile?.Company_PAN_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="GST number" value={companyProfile?.Company_GST_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="MSME number" value={companyProfile?.Company_MSME_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company address" value={companyProfile?.Company_address || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company mobile number" value={companyProfile?.Company_Mobile_number || ""} disabled radius="xs" size="md" />
                            <TextInput label="Company email id" value={companyProfile?.Company_email || ""} disabled radius="xs" size="md" />
                        </Group>
                        <Divider label="Terms and conditions" my="sm" variant="dashed" labelPosition="center" />
                        <Paper
                            withBorder
                            shadow="xs"
                            p="xl"
                            radius="md"
                            style={{
                                backgroundColor: "#fff",
                            }}
                        >

                            <Stack gap="lg">

                                {/* ================================= */}
                                {/* TITLE */}
                                {/* ================================= */}

                                <Title order={3}>
                                    Terms & Conditions
                                </Title>

                                <Text size="sm" c="dimmed">
                                    Please read and accept all terms and conditions carefully
                                    before proceeding further.
                                </Text>

                                <Divider />

                                {/* ================================= */}
                                {/* AUTHORIZED SIGNATORY */}
                                {/* ================================= */}

                                <Select
                                    label="Authorized Signatory"
                                    placeholder="Select Authorized Signatory"
                                    withAsterisk
                                    data={
                                        companyProfile?.Directors
                                            ?.filter(d => d.Is_Authroized_signatory)
                                            ?.map((d) => ({
                                                value: d?.Director_name,
                                                label: d?.Director_name,
                                            })) || []
                                    }
                                    value={authorizedSignatory}
                                    onChange={setAuthorizedSignatory}
                                />

                                {/* ================================= */}
                                {/* MAIN ACCEPTANCE */}
                                {/* ================================= */}

                                <Checkbox
                                    checked={acceptMainTerms}
                                    onChange={(event) =>
                                        setAcceptMainTerms(
                                            event.currentTarget.checked
                                        )
                                    }
                                    label={
                                        <Text size="sm">
                                            Yes, I accept all{" "}
                                            <strong>
                                                BOOM PAY TECHNOLOGY PRIVATE LIMITED
                                            </strong>{" "}
                                            terms and conditions and confirm that all
                                            details submitted by me are correct, valid,
                                            and updated.
                                        </Text>
                                    }
                                />

                                <Divider />

                                {/* ================================= */}
                                {/* SERVICES TABLE */}
                                {/* ================================= */}

                                <Title order={5}>
                                    Service-wise Acceptance
                                </Title>

                                <Table
                                    withTableBorder
                                    withColumnBorders
                                    striped
                                    highlightOnHover
                                >

                                    <Table.Thead>

                                        <Table.Tr>

                                            <Table.Th>
                                                S.No
                                            </Table.Th>

                                            <Table.Th>
                                                Service Name
                                            </Table.Th>

                                            <Table.Th>
                                                Accept Terms
                                            </Table.Th>

                                        </Table.Tr>

                                    </Table.Thead>

                                    <Table.Tbody>

                                        {acceptedServices?.map(
                                            (service, index) => (

                                                <Table.Tr key={index}>

                                                    <Table.Td>
                                                        {index + 1}
                                                    </Table.Td>

                                                    <Table.Td>
                                                        {service.service_name}
                                                    </Table.Td>

                                                    <Table.Td>

                                                        <Select
                                                            placeholder="Accept"
                                                            data={["Yes"]}
                                                            value={
                                                                service.is_accepted
                                                                    ? "Yes"
                                                                    : null
                                                            }
                                                            onChange={(value) =>
                                                                handleServiceAcceptance(
                                                                    index,
                                                                    value
                                                                )
                                                            }
                                                        />

                                                    </Table.Td>

                                                </Table.Tr>
                                            )
                                        )}

                                    </Table.Tbody>

                                </Table>

                                {/* ================================= */}
                                {/* FINAL NOTE */}
                                {/* ================================= */}

                                <Alert type="warning" title={<Text size="sm">

                                    By accepting the above terms and conditions,
                                    you confirm that all documents, company details,
                                    and service usage information submitted during
                                    onboarding are genuine and legally valid.

                                </Text>} />

                                {/* ================================= */}
                                {/* SUBMIT BUTTON */}
                                {/* ================================= */}

                                {/* <Button
                                    size="md"
                                    disabled={
                                        !acceptMainTerms ||
                                        acceptedServices.some(
                                            (service) => !service.is_accepted
                                        )
                                    }
                                    onClick={handleSubmitTermsAndConditions}
                                >

                                    Submit for verification

                                </Button> */}
                                <Button
                                    size="md"
                                    disabled={
                                        !acceptMainTerms ||
                                        acceptedServices.some(
                                            (service) => !service.is_accepted
                                        )
                                    }
                                    loading={loading}
                                    onClick={
                                        rectification
                                            ? handleRectificationSubmit
                                            : handleSubmitTermsAndConditions
                                    }
                                >
                                    {
                                        rectification
                                            ? "Submit Rectification"
                                            : "Submit for verification"
                                    }
                                </Button>

                            </Stack>

                        </Paper>

                    </Card>
                </Spin>
            </Flex>

        </>
    )
}
export default Termsandconditions